<template lang="pug">
v-dialog(v-model="dialog", max-width="500")
  v-card
    v-toolbar(flat, dense)
      .subtitle-2 Recent Member Activities
    v-divider
    v-tabs
      v-tab Redeem Activities
      v-tab Earn Activities
      v-tab-item
        Table(:items="redeems")
      v-tab-item
        Table(:items="earns")
</template>

<script>
import { EventBus } from "@/event-bus.js";
import Table from "./Table";

export default {
  components: { Table },
  data() {
    return {
      dialog: false,
      redeems: [],
      earns: [],
    };
  },
  mounted() {
    EventBus.$on("show-member-activities", this.load);
  },
  destroyed() {
    EventBus.$off("show-member-activities", this.load);
  },
  methods: {
    load(memberId) {
      if (!memberId) return;
      this.dialog = true;
      const params = {
        criteria: { member: memberId },
        select: "amount",
        limit: 10,
      };
      this.axios.post("/pointredeem/list", params).then((response) => {
        this.redeems = response.data;
      });
      this.axios.post("/pointearn/list", params).then((response) => {
        this.earns = response.data;
      });
    },
  },
};
</script>
